import { useEffect } from "react";
import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";

const BOOKING_URL = "https://booking-socializevideo-production.up.railway.app";

export default function Book() {
  useEffect(() => {
    document.title = "Book a Build Consult — Socialize Video";
  }, []);

  return (
    <div className="bg-bg min-h-screen" data-testid="book-page">
      {/* HERO */}
      <section className="pt-20 pb-10">
        <div className="container-x max-w-2xl">
          <Reveal>
            <div className="eyebrow mb-6">Book a build consult</div>
            <h1 className="display-hero mb-6" style={{ fontSize: "clamp(2.2rem, 5vw, 3.4rem)" }}>
              Talk through your build.
            </h1>
            <p className="text-lg text-ink/80 leading-relaxed max-w-xl">
              Thirty minutes, one on one. We'll look at what your business needs online —
              a website, a tool, or both — and I'll tell you honestly whether I can build it
              and what it takes. No pitch, no pressure.
            </p>
          </Reveal>
        </div>
      </section>

      {/* BOOKING WIDGET */}
      <section className="pb-20">
        <div className="container-x max-w-2xl">
          <div className="bg-surface rounded-2xl p-6 md:p-8">
            <iframe
              id="booking-embed-frame"
              src={`${BOOKING_URL}/?embed=1`}
              title="Book a build consult with Socialize Video"
              className="w-full border-0"
              style={{ minHeight: 320, height: 960 }}
              loading="lazy"
            />
            <p className="text-center text-sm text-muted mt-4">
              Trouble seeing the scheduler?{" "}
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="text-teal underline">
                Open it in a new window
              </a>.
            </p>
            <script
              dangerouslySetInnerHTML={{
                __html: `(function(){var f=document.getElementById('booking-embed-frame');if(!f)return;window.addEventListener('message',function(ev){var d=ev&&ev.data;if(!d||d.type!=='booking-hub:height'||d.source!=='booking-socializevideo')return;var h=parseInt(d.height,10);if(h>200)f.style.height=h+'px';});f.addEventListener('load',function(){try{f.contentWindow.postMessage({type:'booking-hub:request-height'},'*')}catch(e){}});})();`,
              }}
            />
          </div>
          <p className="text-center text-sm text-muted mt-6">
            Prefer to write first? <Link to="/apply" className="text-teal underline">Apply for a build</Link> — I review every application personally.
          </p>
        </div>
      </section>
    </div>
  );
}